import { useMemo } from "react"
import { useAccountInfoCtx } from "./useAccountInfo"

/**
 * 業者アサイン機能で使用するエンティティの型
 * Operation または CleaningInfoDetail が持つべきプロパティ
 */
interface WithCompanyAssignment {
    companyId?: string
    cleaningCompanyId?: string
}

/**
 * 業者アサイン機能の状態を判定するカスタムフック
 *
 * @param entity - Operation または CleaningInfoDetail などの業者情報を持つエンティティ
 * @returns 業者アサイン関連の判定結果
 *
 * @example
 * ```tsx
 * const { isOwner, hasAssignedCompany, isAssignedCompany } =
 *     useCompanyAssignmentStatus(operation)
 * ```
 */
export const useCompanyAssignmentStatus = (
    entity: WithCompanyAssignment | undefined
) => {
    const { jwtPayload } = useAccountInfoCtx()

    const result = useMemo(() => {
        // エンティティのOwnerはそのエンティティを所有する会社（通常はMatsuri）
        const isOwner = entity?.companyId === jwtPayload.companyId

        // 業者がアサインされているかどうか
        const hasAssignedCompany = !!entity?.cleaningCompanyId

        // ログイン中の会社がアサインされた業者かどうか
        const isAssignedCompany =
            entity?.cleaningCompanyId === jwtPayload.companyId

        return {
            isOwner,
            hasAssignedCompany,
            isAssignedCompany
        }
    }, [entity?.companyId, entity?.cleaningCompanyId, jwtPayload.companyId])

    return result
}
